var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-btn', {
    staticStyle: {
      "border-radius": "8px!important"
    },
    attrs: {
      "x-large": "",
      "block": "",
      "color": "primary",
      "to": "/exchange"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "gap": "8px"
    },
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-wallet-giftcard")]), _c('span', [_vm._v("교환소")])], 1)], 1)], 1), _c('v-col', [_c('v-btn', {
    staticStyle: {
      "border-radius": "8px!important"
    },
    attrs: {
      "x-large": "",
      "block": "",
      "color": "primary",
      "to": "/mypage/cashes/charge"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "gap": "8px"
    },
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-plus-circle-outline")]), _c('span', [_vm._v("캐시충전")])], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }